import { SearchConditionParams } from 'components/SearchSideBar/types';
import { createOccupationUrlQuery } from 'components/SearchSideBar/logics/createQuery/occupationQuery';
import { createJobOfferKindQuery } from 'components/SearchSideBar/logics/createQuery/details/jobOfferKind';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { createConditionQuery } from 'logics/createConditionQuery';
import { DEFAULT_PARAMS } from '../../../../constants';

/**
 * クエリ生成に渡される引数
 */
interface ArgumentType {
  /** 選択中の条件 */
  selectedCurrentCondition: SelectedCurrentConditionType;
  /** デフォルトパラメータ */
  defaultParams: typeof DEFAULT_PARAMS;
  /** フィーチャーIDクエリ */
  fidQuery: string | undefined;
}

/**
 * 特集枠案件一覧画面サイドバー用検索条件のクエリを作成
 *
 * @param {ArgumentType} root0 - クエリ生成に渡される引数
 * @returns {SearchConditionParams} - 生成された検索条件クエリオブジェクト
 */
export const createConditionQueryObject = ({
  selectedCurrentCondition,
  defaultParams,
  fidQuery,
}: ArgumentType): SearchConditionParams => {
  // 各条件のクエリを生成
  const occupationQuery = createOccupationUrlQuery(
    selectedCurrentCondition.searchJobTypeLId,
    selectedCurrentCondition.searchJobTypeMId,
    selectedCurrentCondition.searchJobTypeSId
  );

  const areaQuery = createConditionQuery(selectedCurrentCondition.areaId, 'ar');
  const prefectureQuery = createConditionQuery(
    selectedCurrentCondition.prefectureId,
    'pr'
  );
  const cityQuery = createConditionQuery(selectedCurrentCondition.cityId, 'ci');
  const wardQuery = createConditionQuery(selectedCurrentCondition.wardId, 'wa');
  const routeQuery = createConditionQuery(
    selectedCurrentCondition.routeId,
    'rt'
  );
  const stationQuery = createConditionQuery(
    selectedCurrentCondition.stationId,
    'st'
  );
  const jobOfferKindQuery = createJobOfferKindQuery(
    selectedCurrentCondition?.jobOfferKind,
    defaultParams?.tp
  );

  return {
    fid: `fid=${fidQuery}`,
    oc: occupationQuery,
    ar: areaQuery,
    pr: prefectureQuery,
    ci: cityQuery,
    wa: wardQuery,
    rt: routeQuery,
    st: stationQuery,
    ss: defaultParams ? `ss=${defaultParams.ss}` : undefined,
    pic: defaultParams ? `pic=${defaultParams.pic}` : undefined,
    ds: defaultParams ? `ds=${defaultParams.ds}` : undefined,
    tp: jobOfferKindQuery,
    bf: defaultParams ? `bf=${defaultParams.bf}` : undefined,
    fasetFlg: defaultParams ? `fasetFlg=${defaultParams.fasetFlg}` : undefined,
  };
};
